import { Loader2 } from 'lucide-react';
import React from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Z_INDEX_MODAL_NESTED } from '@/components/ui/zIndex';

interface HipaaVoidConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
  isVoiding: boolean;
  zIndex?: number;
}

export const HipaaVoidConfirmDialog: React.FC<HipaaVoidConfirmDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  isVoiding,
  zIndex = Z_INDEX_MODAL_NESTED,
}) => {
  const handleConfirm = async () => {
    try {
      await onConfirm();
      onOpenChange(false);
    } catch {
      // Keep dialog open on error
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent style={{ zIndex }} overlayStyle={{ zIndex }}>
        <AlertDialogHeader>
          <AlertDialogTitle>Void Signature Request?</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to void this HIPAA Authorization request? The
            signer will no longer be able to sign, and this action cannot be
            undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isVoiding}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={isVoiding}
            className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            {isVoiding ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                Voiding...
              </>
            ) : (
              'Void Request'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
